module.exports = __WEBPACK_EXTERNAL_MODULE_h4G9__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"@fiverr/i18n/singleton","commonjs2":"@fiverr/i18n/singleton","amd":"@fiverr/i18n/singleton","root":"i18n","var":"i18n"}
// module id = h4G9
// module chunks = 0 1